import React, { useState } from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';

import FontAwesomeIcon from '../../../../components/common/FontAwesomeIcon';
import { Text } from '../../../../components/common/Texts';
import { parseLocatedDate } from '../../../../utils/dates';

import { ScheduleRounded } from '@mui/icons-material';
import { Card } from '@mui/material';

import { useSelector } from 'react-redux';
import RegisterClassEventModal from '../../../events/components/modals/RegisterClassEventModal';
import EventSuccessModal from '../../../events/components/modals/EventSuccessModal';

const ClassEventsCard = (props) => {
    const { event, getDynamicEvent, tabsFake } = props;

    const colorPrimary = useSelector(
        (state) => state?.ondemand?.ondemand?.primary_color
    );

    const [openModal, setOpenModal] = useState(false);
    const [openSuccessModal, setOpenSuccessModal] = useState(false);

    moment.updateLocale('es', {
        months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split(
            '_'
        ),
        monthsShort:
            'Enero._Feb._Mar_Abr._May_Jun_Jul._Ago_Sept._Oct._Nov._Dec.'.split(
                '_'
            ),
        weekdays: 'Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Dom._Lun._Mar._Mier._Jue._Vier._Sab.'.split('_'),
        weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_'),
    });

    const normalizeModality = (modality) => {
        if (!modality) return 'online';
        const lowerModality = modality.toLowerCase();
        if (
            lowerModality.includes('physical') ||
            lowerModality.includes('presencial') ||
            lowerModality.includes('Physical Event')
        ) {
            return 'physical';
        }
        return 'online';
    };

    const normalizedModality = normalizeModality(event.modality);

    const currentDate = new Date();
    const formatCurrentDate = moment(currentDate).locale('es').format('LL');

    // Usar date_begin que viene en UTC y convertir a fecha local
    const eventDateBegin = event?.date_begin
        ? moment.utc(event.date_begin).toDate()
        : new Date();

    const formatEventDateBegin = moment(eventDateBegin)
        .locale('es')
        .format('LL');

    // Función para convertir hora UTC a timezone específico
    const getEventHourInTimezone = (timezone) => {
        if (!event?.date_begin) return '00:00';
        // date_begin viene en UTC, lo parseamos como UTC y convertimos al timezone
        const eventMoment = moment.utc(event.date_begin).tz(timezone);
        return eventMoment.format('HH:mm');
    };

    const monthNames = [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre',
    ];

    const monthNamesShort = [
        'ENE',
        'FEB',
        'MAR',
        'ABR',
        'MAY',
        'JUN',
        'JUL',
        'AGO',
        'SEP',
        'OCT',
        'NOV',
        'DIC',
    ];

    const ToggleLocationHour = (props) => {
        const { toggler } = props;
        const timezoneMap = {
            Argentina: 'America/Argentina/Buenos_Aires',
            Panama: 'America/Panama',
            'Costa Rica': 'America/Costa_Rica',
        };

        const countryCode = {
            Argentina: ' (AR) ',
            Panama: ' (PA) ',
            'Costa Rica': ' (CR) ',
        };

        const timezone = timezoneMap[toggler] || timezoneMap['Argentina'];
        const hour = getEventHourInTimezone(timezone);

        return (
            <Text fontSize="11px" color="#616161" component="span">
                {hour}
                {countryCode[toggler] || countryCode['Argentina']}
            </Text>
        );
    };

    const handleClick = () => {
        setOpenModal(!openModal);
    };

    const handleModalSuccess = () => {
        setOpenSuccessModal(!openSuccessModal);
        if (openSuccessModal && getDynamicEvent) {
            getDynamicEvent();
        }
    };

    return (
        <>
            {openModal && (
                <RegisterClassEventModal
                    event={event}
                    handleClick={handleClick}
                    handleModalSuccess={handleModalSuccess}
                    getDynamicEvent={getDynamicEvent}
                    tabsFake={tabsFake}
                />
            )}
            {openSuccessModal && (
                <EventSuccessModal
                    handleModal={handleModalSuccess}
                    openModal={openSuccessModal}
                />
            )}
            <CardFake
                isRegistered={event.is_registered}
                colorPrimary={colorPrimary}
                type={normalizedModality}
                onClick={handleClick}
                hasCycle={event?.cycle_id !== 0}
            >
                <Body color="#fff" type={normalizedModality}>
                    {normalizedModality === 'physical' && (
                        <>
                            <Footer>
                                <DateWrapper
                                    isRegistered={event.is_registered}
                                    title={`${eventDateBegin.getDate()} de ${monthNames[eventDateBegin.getMonth()]}`}
                                >
                                    <FontAwesomeIcon
                                        icon="fa-regular fa-calendar-day"
                                        size={16}
                                        color={'#fff'}
                                    />
                                    <p>
                                        {eventDateBegin.getDate()} de{' '}
                                        {
                                            monthNamesShort[
                                                eventDateBegin.getMonth()
                                            ]
                                        }
                                    </p>
                                </DateWrapper>
                                <WrapperInscription
                                    colorPrimary={colorPrimary}
                                    type={event.is_registered}
                                >
                                    {event.is_registered ? (
                                        <>
                                            <FontAwesomeIcon
                                                icon="fa-regular fa-check"
                                                size={20}
                                            />{' '}
                                            Inscripto
                                        </>
                                    ) : (
                                        <>
                                            <FontAwesomeIcon
                                                icon="fa-regular fa-plus"
                                                size={20}
                                            />{' '}
                                            Inscribirme
                                        </>
                                    )}
                                </WrapperInscription>
                            </Footer>
                        </>
                    )}
                    {normalizedModality === 'online' &&
                        ((eventDateBegin === currentDate ||
                            formatEventDateBegin === formatCurrentDate) &&
                        event.is_registered ? (
                            <Footer>
                                <DateWrapper
                                    isRegistered={event.is_registered}
                                    title={`${eventDateBegin.getDate()} de ${monthNames[eventDateBegin.getMonth()]}`}
                                >
                                    <FontAwesomeIcon
                                        icon="fa-regular fa-calendar-day"
                                        size={16}
                                        color={'#fff'}
                                    />
                                    <p>
                                        {eventDateBegin.getDate()} de{' '}
                                        {
                                            monthNamesShort[
                                                eventDateBegin.getMonth()
                                            ]
                                        }
                                    </p>
                                </DateWrapper>
                                <WrapperText>
                                    <CircleLive />
                                    <Text
                                        fontSize="11px"
                                        color="#b31d15"
                                        fontWeight="bold"
                                        component="span"
                                    >
                                        EN VIVO HOY
                                    </Text>
                                </WrapperText>
                            </Footer>
                        ) : event.is_registered ? (
                            <Footer>
                                <DateWrapper
                                    isRegistered={event.is_registered}
                                    title={`${eventDateBegin.getDate()} de ${monthNames[eventDateBegin.getMonth()]}`}
                                >
                                    <FontAwesomeIcon
                                        icon="fa-regular fa-calendar-day"
                                        size={16}
                                        color={'#fff'}
                                    />
                                    <p>
                                        {eventDateBegin.getDate()} de{' '}
                                        {
                                            monthNamesShort[
                                                eventDateBegin.getMonth()
                                            ]
                                        }
                                    </p>
                                </DateWrapper>
                                <WrapperInscription
                                    colorPrimary={colorPrimary}
                                    type={true}
                                >
                                    <FontAwesomeIcon
                                        icon="fa-regular fa-check"
                                        size={20}
                                    />{' '}
                                    Inscripto
                                </WrapperInscription>
                            </Footer>
                        ) : (
                            <Footer>
                                <DateWrapper
                                    isRegistered={event.is_registered}
                                    title={`${eventDateBegin.getDate()} de ${monthNames[eventDateBegin.getMonth()]}`}
                                >
                                    <FontAwesomeIcon
                                        icon="fa-regular fa-calendar-day"
                                        size={16}
                                        color={'#fff'}
                                    />
                                    <p>
                                        {eventDateBegin.getDate()} de{' '}
                                        {
                                            monthNamesShort[
                                                eventDateBegin.getMonth()
                                            ]
                                        }
                                    </p>
                                </DateWrapper>
                                <WrapperInscription
                                    colorPrimary={colorPrimary}
                                    type={false}
                                >
                                    <FontAwesomeIcon
                                        icon="fa-regular fa-plus"
                                        size={20}
                                    />{' '}
                                    Inscribirme
                                </WrapperInscription>
                            </Footer>
                        ))}
                    <TextFakeWrapper>
                        <TextFake
                            id="title"
                            fontSize="14px"
                            fontWeight="bold"
                            color="#222222"
                        >
                            {event.publication_name}
                        </TextFake>
                    </TextFakeWrapper>
                    <WrapperText>
                        <ScheduleRounded />
                        {normalizedModality === 'online' ? (
                            <>
                                <ToggleLocationHour toggler={'Argentina'} />
                                |
                                <ToggleLocationHour toggler={'Panama'} />
                                |
                                <ToggleLocationHour toggler={'Costa Rica'} />
                            </>
                        ) : (
                            <Text
                                fontSize="12px"
                                color={'#616161'}
                                component="span"
                            >
                                {event?.date_begin_located
                                    ? parseLocatedDate(event.date_begin_located)?.format('HH:mm') ?? event?.hour_begin
                                    : event?.hour_begin}{' '}
                                {event?.headquarter_country || `(Hora local)`}
                            </Text>
                        )}
                    </WrapperText>
                    {normalizedModality === 'physical' && (
                        <WrapperText>
                            <FontAwesomeIcon
                                icon="fa-light fa-location-dot"
                                size={16}
                            />
                            <Text
                                fontSize="12px"
                                color={'#616161'}
                                component="span"
                            >
                                {event?.headquarter_country ||
                                    event?.location?.country_name}
                                {event?.headquarter_city ||
                                event?.location?.city
                                    ? `, ${event.headquarter_city || event.location.city}`
                                    : ''}
                                {event?.headquarter_address ||
                                event?.location?.street
                                    ? `, ${event.headquarter_address || event.location.street}`
                                    : ''}
                                {event?.headquarter_address === '' &&
                                    `, ${event?.city}, ${event?.district}, ${event?.address}`}
                            </Text>
                        </WrapperText>
                    )}
                    {event?.cycle_id !== 0 && (
                        <CycleChip>{event?.cycle_name}</CycleChip>
                    )}
                </Body>
            </CardFake>
        </>
    );
};

export default ClassEventsCard;

const CardFake = styled(Card)`
    box-sizing: border-box;
    display: inline-flex;
    position: relative;
    align-items: center;
    gap: 2rem;
    min-height: ${(p) => (p.hasCycle ? '182px' : '142px')};
    cursor: pointer;
    width: 100%;
    border-radius: 10px;
    box-shadow:
        0px 6px 12px -6px rgba(24, 39, 75, 0.12),
        0px 8px 24px -4px rgba(24, 39, 75, 0.08);
    scale: ${(p) => p.scale};
    border: 1px solid #dcdcdc;

    :before {
        content: '';
        width: 8px;
        background-color: #dcdcdc;
        position: absolute;
        height: 100%;
        left: 0;
        z-index: 1;
    }

    :hover {
        :before {
            background-color: ${(p) =>
                !!p.isRegistered
                    ? '#35d0a5'
                    : p.colorPrimary
                      ? p.colorPrimary
                      : '#b31d15'};
        }
    }
`;

const TextFakeWrapper = styled.div`
    height: auto;
    width: 100%;
`;

const TextFake = styled(Text)`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;

const Body = styled.div`
    display: inline-flex;
    flex-direction: column;
    padding: 1rem;
    gap: ${({ type }) => (type === 'physical' ? '.7rem' : '1.6rem')};
    position: relative;
    width: calc(100% - 25px);
    max-width: calc(100% - 25px);
    background: white;
    align-items: ${(p) => (p.type === 'default' ? 'center' : 'flex-start')};
    transition: ease-in-out 0.3s all;
`;

const WrapperText = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;

    svg {
        font-size: 16px;
        color: #a8a8a8;
    }
`;

const WrapperInscription = styled.div`
    border-radius: 5px;
    display: flex;
    align-items: center;
    gap: 6px;
    color: ${(p) =>
        p.type ? '#28A986' : !!p.colorPrimary ? p.colorPrimary : '#b31d15'};
    font-size: 13px;
    padding: 0.2rem;
    font-weight: 700;
    svg {
        font-size: 1.1rem;
    }
`;

const CircleLive = styled.div`
    min-width: 12px;
    min-height: 12px;
    background-color: #b31d15;
    border-radius: 50%;
`;

const Footer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
`;

const DateWrapper = styled.div`
    display: flex;
    gap: 0.3rem;
    background-color: ${(p) => (p.isRegistered ? '#28A986' : '#B31D15')};
    padding: 8px 14px 8px 10px;
    border-radius: 100px;
    max-width: fit-content;
    min-width: 0;

    p {
        color: #fff;
        font-weight: 700;
        font-size: 13px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 120px;
    }
`;

const CycleChip = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    background-color: transparent;
    color: #616161;
    border: 1px solid #616161;
    padding: 4px 8px;
    border-radius: 100px;
    font-size: 11px;
    font-weight: 600;
`;
